import React, { useState } from "react";
import { Box, Button, Popover, Typography } from "@mui/material";

export const LC_SUMMARY_ITEMS = [
  { key: "newSkuCount", label: "New" },
  { key: "existingSkuCount", label: "Existing" },
  { key: "excludedCount", label: "Excluded" },
];

export const DC_SUMMARY_ITEMS = [
  { key: "blockedCount", label: "Paused" },
  { key: "flaggedCount", label: "Flagged" },
  { key: "rejectedCount", label: "Rejected" },
  { key: "escalatedCount", label: "Escalated" },
  { key: "approvedCount", label: "Approved" },
  { key: "draftCount", label: "Draft" },
  { key: "estimatedCount", label: "Estimated" },
  { key: "excludedCount", label: "Excluded" },
];

const countValue = (summary, key) => Number(summary?.[key] ?? 0);

const CJWRecordSummaryCell = ({ title, summary, items, available }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  if (!available) {
    return (
      <Typography component="span" color="text.secondary" aria-label={`${title} unavailable`}>
        —
      </Typography>
    );
  }

  const open = Boolean(anchorEl);
  const openSummary = (event) => setAnchorEl(event.currentTarget);
  const closeSummary = () => setAnchorEl(null);

  return (
    <>
      <Button
        size="small"
        variant="text"
        aria-label={`View ${title} counts`}
        aria-haspopup="dialog"
        aria-expanded={open}
        onMouseEnter={openSummary}
        onMouseLeave={closeSummary}
        onFocus={openSummary}
        onBlur={closeSummary}
        onClick={(event) => {
          event.stopPropagation();
          openSummary(event);
        }}
        sx={{ minWidth: 0, px: 0.5, textTransform: "none" }}
      >
        View counts
      </Button>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={closeSummary}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        sx={{ pointerEvents: "none" }}
        PaperProps={{ sx: { p: 1.5, minWidth: 220 } }}
      >
        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
          {title}
        </Typography>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr auto",
            columnGap: 3,
            rowGap: 0.5,
          }}
        >
          {items.map(({ key, label }) => (
            <React.Fragment key={key}>
              <Typography variant="body2">{label}</Typography>
              <Typography variant="body2" sx={{ fontWeight: 600, textAlign: "right" }}>
                {countValue(summary, key)}
              </Typography>
            </React.Fragment>
          ))}
        </Box>
      </Popover>
    </>
  );
};

export default CJWRecordSummaryCell;
